module.exports = __webpack_public_path__ + "static/media/photo52.bff33637.jpg";